import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { getCancelSharingPath } from '../api';
export const useCancelSharing = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching: isCancelling
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = sharingId => fetcher(getCancelSharingPath(sharingId));
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cancelSharing = t1;
  let t2;
  if ($[3] !== cancelSharing || $[4] !== isCancelling) {
    t2 = {
      cancelSharing,
      isCancelling
    };
    $[3] = cancelSharing;
    $[4] = isCancelling;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};